<div *ngIf="compilation" 
    class="ml-2 text-center dnstatus" 
    [ngStyle]="{'background-color': dnStatusColor}"
>
    <b>{{dnStatusText}}</b>
    <!-- <ng-container *ngIf="that.incomingShipmentEnRoute[compilation.code]"><br>(Incoming Shipment En Route)</ng-container> -->
    <ng-container *ngIf="enRoute"><br>(Incoming Shipment En Route)</ng-container>

</div>
